


























































































import Vue from 'vue'
import Table from './components/Table.vue'
import TableFull from './components/Table-full.vue'
import TableSearch from './components/Table-search.vue'
import Stats from './components/Stats.vue'

import {keys} from '../src/keys'
import {URLs} from '../src/main'

export default Vue.extend({
  name: 'App',

  components: {
    Table,
    TableFull,
    TableSearch,
    Stats
  },

  data: function() {
    return {
      products: [
        {id: 1, name: "string", price: 10, index: 1}
      ],
      isEmpty: false,

      newProductName: '',
      newProductPrice: '',

      editProductID: '',
      editProductIndex: '',
      editProductName: '',
      editProductPrice: '',

      productStats: {
        totalProducts: 0,
        avgProductPrice: 0,
        totalProductsValue: 0,
        avgNameLength: 0,
        totalExpensive: 0,
      },

      priceCategories: [
        { value: 0, label: '$0 - $10', color: '#ff5252' },
        { value: 0, label: '$11 - $100', color: '#448aff' },
        { value: 0, label: '$101 - $1,000', color: '#ffb744' },
        { value: 0, label: '$1,001 - $10,000', color: '#54c72e' },
        { value: 0, label: '$10,000 +', color: '#6b2ec7' }
      ],

      showSnackbar: false,
      currentPage: 0,
      componentKey: 0
    }
  },

  methods: {
    addProduct(newName: string, newPrice: number) { //http post
      const newID = this.products.length + 1;
      
      Vue.axios
        .post(URLs.proxy + URLs.app + 'product/' + keys.backend, {
          name: newName,
          price: newPrice
        })
        .then(() => {
          this.products.push({
            id: newID,
            name: newName,
            price: newPrice,
            index: newID
          });

          this.loadStats();
          this.loadPrices();

          this.isEmpty = false;
        })
        .catch(error => {
          alert("The product API could not be reached right now.");
          console.log(error);
        });
    },

    resetAdd() {
      this.newProductName = '';
      this.newProductPrice = '';
      this.$modal.hide('add-product');
      this.showSnackbar = false;
    },

    proceedWithAdd() {
      if (isNaN(+this.newProductPrice)) {
        this.showSnackbar = true;
      }
      else {
        this.addProduct(this.newProductName, parseInt(this.newProductPrice));
        this.resetAdd();
      }
    },

    openEditModal(id: number, index: number) {
      this.editProductID = id.toString();
      this.editProductIndex = index.toString();
      this.editProductName = this.products[index-1].name;
      this.editProductPrice = this.products[index-1].price.toString();
      this.$modal.show('edit-product');
    },

    editProduct(id: number, newName: string, newPrice: number, index: number) { //http put
    Vue.axios
      .put(URLs.proxy + URLs.app + 'product/' + id + '/' + keys.backend, {
        name: newName,
        price: newPrice
      })
      .then(() => {
        this.products[index-1].name = newName;
        this.products[index-1].price = newPrice;

        this.loadStats();
        this.loadPrices();
      })
      .catch(error => {
        alert("The product API could not be reached right now.");
        console.log(error);
      });
    },

    resetEdit() {
      this.editProductID = '';
      this.editProductName = '';
      this.editProductPrice = '';
      this.$modal.hide('edit-product');
      this.showSnackbar = false;
    },

    proceedWithEdit() {
      if (isNaN(+this.editProductPrice)) {
        this.showSnackbar = true;
      }
      else {
        this.editProduct(parseInt(this.editProductID), this.editProductName, parseInt(this.editProductPrice), parseInt(this.editProductIndex));
        this.resetEdit();
      }
    },

    deleteProduct(id: number, index: number) { //http delete
      Vue.axios
        .delete(URLs.proxy + URLs.app + 'product/' + id + '/' + keys.backend)
        .then(() => {
          this.products.splice(index-1, 1);
          this.reIndex();

          this.loadStats();
          this.loadPrices();
        })
        .catch(error => {
          alert("The product API could not be reached right now.");
          console.log(error);
        });
    },

    reIndex() {
      this.isEmpty = false;
      for (let i = 1; i <= this.products.length; i++) {
        this.products[i-1].index = i;
      }

      if (this.products.length == 0) {
        this.isEmpty = true;
      }
    },
    
    loadStats() {
      const ammount = this.products.length;

      let totalPrice = 0;
      let totalNameLength = 0;
      let above10k = 0;
      this.products.forEach(product => {
        totalPrice += product.price;
        totalNameLength += product.name.length
        if (product.price > 10000) above10k ++;
      });

      this.productStats.totalProducts = ammount;
      this.productStats.avgProductPrice = Math.round(totalPrice / ammount);
      this.productStats.totalProductsValue = totalPrice;
      this.productStats.avgNameLength = Math.round(totalNameLength / ammount);
      this.productStats.totalExpensive = above10k;
    },

    loadPrices() {
      let to10 = 0;
      let to100 = 0;
      let to1000 = 0;
      let to10000 = 0;
      let over10k = 0;
      this.products.forEach(product => {
        const value = product.price;
        if (value < 11) to10 ++;
        else if (value < 101) to100 ++;
        else if (value < 1001) to1000 ++;
        else if (value < 10001) to10000 ++;
        else over10k ++;
      });
      const total = to10 + to100 + to1000 + to10000 + over10k;

      this.priceCategories[0].value = (to10 / total) * 100;
      this.priceCategories[1].value = (to100 / total) * 100;
      this.priceCategories[2].value = (to1000 / total) * 100;
      this.priceCategories[3].value = (to10000 / total) * 100;
      this.priceCategories[4].value = (over10k / total) * 100;
    }
  },

  beforeMount() { //http get
    this.products.length = 0;
    Vue.axios
      .get(URLs.proxy + URLs.app + 'products/' + keys.backend)
      .then(response => {
        this.products = response.data;
        this.loadStats();
        this.loadPrices();

        this.reIndex();
        this.componentKey += 1;
      })
      .catch(error => {
        alert("The product API could not be reached right now.");
        console.log(error);
        this.products = [
          {id: 1, name: "Example product 1", price: 10, index: 1},
          {id: 2, name: "Example product 2", price: 40, index: 2},
          {id: 3, name: "Example product 3", price: 90, index: 3},
        ];
      });
  }

});
